import {useEffect, useState} from "react";
import {useOktaAuth} from "@okta/okta-react";
import {setLogoutFunction,} from "./helper";
import {useAuthConfig} from "./helper";

export function useUserLogin() {
    let authAxios = useAuthConfig();
    const {authState, oktaAuth} = useOktaAuth();
    const [userInfo, setUserInfo] = useState(null);
    const [userSessionObj, setUserSessionObj] = useState(null);
    const hostname = window && window.location && window.location.hostname;

    const logout = async () => {
        // Redirect to '/' after logout
        // clearSessionInfo();
        if (hostname === 'localhost') {
            void oktaAuth.signOut({postLogoutRedirectUrl: 'https://jdsn.tal.deere.com/'});
        }
        if (hostname === 'achieve2.tal.deere.com') {
            void oktaAuth.signOut({postLogoutRedirectUrl: 'https://jdsn.tal.deere.com/'});
        }
        if (hostname === 'achieve2.deere.com') {
            void oktaAuth.signOut({postLogoutRedirectUrl: 'https://jdsn.deere.com/'});
        }
    };

    const getUserRoles = async () => {
        try {
            return await authAxios.get(`/user/roles`);
        } catch (e) {
            console.error(e);
        }
    };

    const getUserSuppliers = async () => {
        try {
            return await authAxios.get(`/user/suppliers`);
        } catch (e) {
            console.error(e);
        }
    };

    const setUserObj = (info, roles, suppliers) => {
        let userObj = {
            userId: info.userID,
            firstName: info.firstName,
            lastName: info.lastName,
            userName:
                info.lastName +
                ", " +
                info.firstName +
                (info.middleInitial !== undefined
                    ? " " + info.middleInitial
                    : ""),
            token: authState.accessToken,
            roles: (roles && roles.length > 0) && roles,
            isCriteriaAdmin: (roles && roles.length > 0)
                ? roles.includes("CRITERIA_CATALOG_ADMIN")
                : false,
            isSupplier: info.userType && (info.userType === "Supplier Employee" || suppliers.length > 0),
            isInternal: info.userType && (info.userType !== "Supplier Employee" && suppliers.length <= 0),
            suppliersList: suppliers
        };
        setUserSessionObj(userObj);
        setUserInfo(info);
    };

    useEffect(() => {
        if (!authState.isAuthenticated) {
            // When user isn't authenticated, forget any user info
            setUserInfo(null);
        } else {
            var isCancelled = false;

            async function inner() {
                const userInfoPromise = oktaAuth.getUser();
                const userRolesPromise = getUserRoles();
                const userSuppliersPromise = getUserSuppliers();

                const userInfo = await userInfoPromise;

                if (!userInfo || isCancelled)
                    return;

                console.log("userType", userInfo.userType);
                setLogoutFunction(logout);

                const [roles, suppliers] = await Promise.all([userRolesPromise, userSuppliersPromise]);

                if (roles && suppliers && !isCancelled)
                    setUserObj(userInfo, roles.data, suppliers.data);
            }

            inner().catch(e => {
                console.error("Error in useUserLogin:", e);
            });

            return () => {
                isCancelled = true;
            };
        }// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState, oktaAuth]); // Update if authState changes

    return [userInfo, logout, userSessionObj];
}

export function getSessionInfo() {
    let obj = sessionStorage.getItem("session");

    return obj === undefined || obj === null ? null : JSON.parse(obj);
}
